import { ListRoot } from "./List";
import { ListProvider } from "./ListContext";
import { ListGroup } from "./ListGroup";
import { ListRow } from "./ListRow";
import { ListEmpty } from "./ListEmpty";

export const List = Object.assign(ListRoot, {
  Provider: ListProvider,
  Group: ListGroup,
  Row: ListRow,
  Empty: ListEmpty,
});

export type {
  ListProps,
  ListProviderProps,
  ListGroupProps,
  ListRowProps,
  ListEmptyProps,
  ListContextValue,
  ListState,
  ListActions,
  ListMeta,
} from "./types";

export { useList } from "./ListContext";
